import { __awaiter } from "tslib";
import EngageVideo from '@getaccept/lib-shared-new/src/video/player/components/EngageVideo.vue';
import { validateEmail } from '@getaccept/lib-shared-new/src/helpers';
import { TemplateService } from '@getaccept/editor-lib-new';
import { ref, computed, onMounted, onUnmounted, defineComponent } from 'vue';
import { LocalStorageHelper } from '@getaccept/lib-shared-new/src/helpers/local-storage.helper';
import { LocalStorageKey } from '@getaccept/lib-shared-new/src/enums/local-storage';
import Signup from '../../signup/components/Signup.vue';
import Page from './Page.vue';
import SignupTemplateSidebar from './SignupTemplateSidebar.vue';
export default defineComponent({
    name: 'SignupTemplateViewer',
    components: {
        Page,
        EngageVideo,
        SignupTemplateSidebar,
        Signup,
    },
    props: { templateId: { type: String, default: '' } },
    setup(props) {
        const showVideo = ref(true);
        const email = ref('');
        const showSignup = ref(false);
        const pageWidth = ref(1000);
        const document = ref(null);
        const loading = ref(false);
        const error = ref(false);
        const pages = computed(() => { var _a; return ((_a = document.value) === null || _a === void 0 ? void 0 : _a.pages) || []; });
        const video = computed(() => { var _a; return ((_a = document.value) === null || _a === void 0 ? void 0 : _a.video) || null; });
        const validEmail = computed(() => email.value.length > 0 && validateEmail(email.value.toLowerCase()));
        const showEngageVideo = computed(() => !!video.value && showVideo.value);
        const handleCloseEngageVideo = () => {
            showVideo.value = false;
        };
        const toggleSignup = () => {
            const isAuthenticated = localStorage.getItem('GA_SESSION_STATE.token');
            LocalStorageHelper.setLocalStorage(LocalStorageKey.Template, props.templateId);
            if (isAuthenticated) {
                window.location.href = '/dashboard';
            }
            else {
                showSignup.value = !showSignup.value;
            }
        };
        const setPageWidth = () => {
            pageWidth.value = window.innerWidth;
        };
        const loadTemplate = () => __awaiter(this, void 0, void 0, function* () {
            try {
                loading.value = true;
                document.value = yield TemplateService.fetch(props.templateId);
            }
            catch (e) {
                error.value = true;
            }
            finally {
                loading.value = false;
            }
        });
        onMounted(() => {
            window.addEventListener('resize', setPageWidth);
            if (props.templateId) {
                loadTemplate();
            }
        });
        onUnmounted(() => {
            window.removeEventListener('resize', setPageWidth);
        });
        return {
            showVideo,
            email,
            showSignup,
            pageWidth,
            document,
            loading,
            error,
            pages,
            video,
            validEmail,
            handleCloseEngageVideo,
            toggleSignup,
            setPageWidth,
            loadTemplate,
            showEngageVideo,
        };
    },
});
